'use strict';

const _=require('pulsar-utils/dist-es6/_');
const GenerateEnum=require('pulsar-utils/dist-es6/domain/generateEnum');
const AlertStatus=GenerateEnum(['NotApplicable','Ok','Warn','Alert'],'AlertStatus');
const ThresholdStatus=require('../../dist-es6/domain/thresholdStatus');

const _thresholdToAlertStatusMap=new Map([
[ThresholdStatus.NotApplicable,AlertStatus.NotApplicable],
[ThresholdStatus.Below,AlertStatus.Ok],
[ThresholdStatus.At,AlertStatus.Warn],
[ThresholdStatus.Above,AlertStatus.Alert]]);


AlertStatus.fromThresholdStatus=function(thresholdStatus){
_.ensureInstanceOf(ThresholdStatus,thresholdStatus);
const status=_thresholdToAlertStatusMap.get(thresholdStatus);
if(!_.exists(status)){
throw new Error('Should never get here');
}
return status;
};

Object.freeze(AlertStatus);

module.exports=AlertStatus;
//# sourceMappingURL=alertStatus.js.map
